import React, { useState } from "react";
import { Form, FormGroup, Label, Input, Button } from "reactstrap";
import {useDispatch} from "react-redux";
import {useNavigate} from "react-router-dom";
import {setSchoolCommentRequest} from "../redux/actions/contractActions";

function SchoolCommentForm({ contract, setSchoolComment }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [comment, setComment] = useState("");
    const [schoolok, setSchoolok] = useState(false);

    const handleCommentChange = (event) => {
        setComment(event.target.value);
    };

    const handleSchoolOkChange = (event) => {
        setSchoolok(event.target.checked);
    }

    const handleSubmit = (event) => {
        dispatch(setSchoolCommentRequest({contractID: contract.ID, schoolok, comment}));
        navigate("/mdb/school/overview");
    };

    return (
        <div className="container my-5">
            <div className="row justify-content-center">
                <div className="col-md-6">
                    <h1 className="mb-3">Vertrag kommentieren</h1>

                    <Form onSubmit={handleSubmit}>
                        <FormGroup>
                            <Label for="comment">Kommentar (optional)</Label>
                            <Input
                                type="textarea"
                                id="comment"
                                value={comment}
                                onChange={handleCommentChange}
                                placeholder="Fügen Sie hier einen Kommentar hinzu..."
                            />
                        </FormGroup>
                        <FormGroup check className="mb-3">
                            <Label check>
                                <Input
                                    type="checkbox"
                                    id="schoolok"
                                    checked={schoolok}
                                    onChange={handleSchoolOkChange}
                                />
                                Befürwortet
                            </Label>
                        </FormGroup>

                        <div className="d-flex justify-content-between">
                            <Button type="cancel" color="secondary" onClick={() => setSchoolComment(null)}
                                    className="ml-2">Abbrechen</Button>
                            <Button type="submit" color="primary">Vertrag beenden</Button>
                        </div>
                    </Form>
                </div>
            </div>
        </div>
    );
}

export default SchoolCommentForm;
